import { Component, Input, ContentChild, TemplateRef } from "@angular/core";
import { ColumnAlign } from "../../types/table.types";

@Component({
  selector: "ds-expand-row",
  template: "",
})
export class DsExpandRowComponent {
  @Input() name!: string;
  @Input() colspan: number = 1;
  @Input() columnAlign: ColumnAlign = "start";

  @ContentChild("dsCell", { static: true }) dsCell: TemplateRef<any>;
}
